import './PrettyErrorModal.pcss';
import React from 'react';
import BasicModalTemplate from '../BasicModalTemplate';
import { ModalInstanceProps } from '../interfaces';
import {
  ActionButton,
  ButtonAudacityLevel,
  ButtonTheme,
} from '../../buttons/ActionButton/ActionButton';
import { OpenPrettyErrorModalParams } from '@mm/state/modules/modalsState/actions';

type Props = ModalInstanceProps & OpenPrettyErrorModalParams;

const getErrorMessage = (errorMessage?: JSX.Element | string) => {
  if (errorMessage) {
    return errorMessage;
  }
  return (
    <span>
      An unexpected error occurred. If this continues please contact
      <a href="mailto:support@mobilemonkey.com"> support@mobilemonkey.com </a>
      for assistance.
    </span>
  );
};

const PrettyErrorModal = (props: Props) => {
  const { title, errorMessage, closeModal, detailsForNerds, onClose } = props;
  const buttonText = props.buttonText || 'Dismiss';

  const onModalClose = () => {
    closeModal();
    if (onClose) {
      onClose();
    }
  };

  return (
    <BasicModalTemplate
      className="pretty-error-modal"
      closeOverride={onModalClose}
    >
      <div className="pretty-error-modal__header">
        <div className="pretty-error-modal__header-text">{title}</div>
      </div>

      <div className="pretty-error-modal__body-wrapper">
        <div className="pretty-error-modal__message">
          {getErrorMessage(errorMessage)}
        </div>

        {detailsForNerds && (
          <div className="pretty-error-modal__extra-details-wrapper">
            <div className="pretty-error-modal__extra-details-title">
              Details for nerds
            </div>

            <div className="pretty-error-modal__extra-details">
              {detailsForNerds}
            </div>
          </div>
        )}

        <ActionButton
          className="pretty-error-modal__dismiss-button"
          onClick={onModalClose}
          theme={ButtonTheme.blueOrangeGradient}
          audacityLevel={ButtonAudacityLevel.timid}
        >
          {buttonText}
        </ActionButton>
      </div>
    </BasicModalTemplate>
  );
};

export { PrettyErrorModal };
